import {Container} from '@inlet/react-pixi';
import {TextBox} from '@gongxigames/framework/core/fragments/react';
import React from 'react';
import {CheatsButton, CheatsButtonButtonProps} from './CheatsButton';

export type ButtonWithTitleProps = {
    title: string;
    fontSize: number;
    onClick: () => void;
    padding?: number;
} & CheatsButtonButtonProps;

export class ButtonWithTitle extends CheatsButton<ButtonWithTitleProps> {
    protected onPointerTap(): void {
        if (this.props.disabled) {
            return;
        }

        this.props.onClick();
    }

    public render(): JSX.Element {
        const {padding = 20} = this.props;

        return (
            <Container {...this.getContainerProps()} >
                <TextBox
                    text={this.props.title}
                    round={4}
                    background={this.state.currentState.background}
                    boxWidth={this.props.width}
                    boxHeight={this.props.height}
                    textStyle={{fontSize: this.props.fontSize, fill: 0xffffff}}
                    textAlign={{horizontal: 'center', vertical: 'center'}}
                    padding={{left: padding, right: padding}}
                />
            </Container>
        );
    }
}
